import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" data-testid="error-boundary" className="mx-auto max-w-md px-6 py-16 text-center">
        <p className="text-lg font-semibold text-slate-900">Algo salió mal · Something went wrong</p>
        <button type="button" data-testid="error-boundary-reload" onClick={() => window.location.reload()} className="mt-4 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white hover:bg-slate-700">Recargar · Reload</button>
      </div>
    );
  }
}
